// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"4620316c","977":"713c0e2f"}[chunkId] + ".chunk.js";
};